define('lq/events/actions/bigBlueButtonStartMeetingCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function BigBlueButtonStartMeeting(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(BigBlueButtonStartMeeting, EventAction);

    BigBlueButtonStartMeeting.typeName = 'BigBlueButtonStartMeetingCommand';

    BigBlueButtonStartMeeting.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    BigBlueButtonStartMeeting.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "StartMeeting",
            morphId: this.eventData.command
        };
    };

    BigBlueButtonStartMeeting.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.success) {
            if (this.eventIsEnabled('meetingStarted'))
                this.triggerEvent('meetingStarted', continuation);
            else
                continuation();
        } else {
            if (this.eventIsEnabled('startFailed'))
                this.triggerEvent('startFailed', continuation);
            else {
                alert('The meeting could not be started.');
                continuation();
            }
        }
    };

    return BigBlueButtonStartMeeting;
});
